import React, { useState } from 'react';
import {
  Typography,
  MenuItem,
  MenuList,
  ListItemText,
  Skeleton,
  InputBase,
  InputAdornment,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

export default function LocationBoxViewer({value, options, onSelect, ...props}) {
  const [search, setSearch] = useState("")
  const normalizedSearch = search.trim().toLowerCase()
  const filteredOptions = options?.filter(x =>
    x.name.toLowerCase().includes(normalizedSearch) || (x.temperature !== null && x.temperature.toString().includes(normalizedSearch))
  )
  return (
    <>
      <InputBase
        placeholder="Filter"
        value={search}
        onChange={event => setSearch(event.target.value)}
        fullWidth
        autoFocus
        sx={{mx: 1, minHeight: 30, py: 0.5, fontSize: '0.875rem'}}
        startAdornment={
          <InputAdornment position="start">
            <SearchIcon fontSize="small" color="action" />
          </InputAdornment>
        }
        inputProps={{"aria-label": "Filter"}}
      />
      <MenuList variant="selectedMenu" {...props}>
			{options ? filteredOptions.map(x => (
				<MenuItem
					key={x.id}
					selected={x.id === value}
					aria-label={x.name}
					aria-selected={x.id === value}
					onClick={() => onSelect(x.id)}
				>
					<ListItemText>
						  {x.name}
						{x.temperature !== null && (
							<Typography variant="caption" color="textSecondary" display="inline">
								{` ${x.temperature}°C`}
							</Typography>
						)}
					</ListItemText>
					{x.num_positions_unoccupied !== null && (
						<Typography variant="caption" color="textSecondary">
							{x.num_positions_unoccupied} spot{x.num_positions_unoccupied === 1 ? '' : 's'}
						</Typography>
					)}
				</MenuItem>
			)) : Array(8).fill().map((_, index) => <MenuItem role="progressbar" key={index}><ListItemText><Skeleton /></ListItemText></MenuItem>)}
      </MenuList>
    </>
  )
}
